/**
 * 입하 라벨 레이아웃 설정
 * 100mm x 100mm 라벨 기준
 */
export const LABEL_LAYOUT = {
  // 페이지 설정
  page: {
    margin: 5,
  },

  // QR 코드 설정
  qr: {
    size: 18, // QR 코드 크기
    topRightOffset: 5, // 우측 상단 QR 오프셋
    bottomLeftOffset: 5, // 좌측 하단 QR 오프셋
  },

  // 색상
  colors: {
    headerBg: '#E8E8E8',
    border: '#000000',
  },

  // 테두리 (모든 셀 동일)
  border: {
    width: 0.4,
    color: '#000000',
  },

  // 폰트 크기
  fonts: {
    large: 10,
    medium: 8,
    small: 7,
  },

  // 행(Row) 높이
  rows: {
    standard: 7, // 일반 행 높이
    title: 16, // 상품명 행 높이
  },

  // 그리드 설정
  grid: {
    totalColumns: 6, // 전체 그리드 열 수
    qr1Width: 1.5, // QR1 너비 (그리드 단위)
    qr2Width: 1.5, // QR2 너비 (그리드 단위)
    qr1Rows: 3, // QR1 병합 행 수
    qr2Rows: 3, // QR2 병합 행 수
  },

  // 텍스트 길이별 반응형 폰트 설정
  responsiveFontSizes: {
    // 상품명
    goodsName: [
      { maxLength: 20, fontSize: 14, textOffsetY: 1 },
      { maxLength: 45, fontSize: 12, textOffsetY: -1 },
      { maxLength: 85, fontSize: 10, textOffsetY: -2 },
      { maxLength: 120, fontSize: 9, textOffsetY: -4 },
      { maxLength: Infinity, fontSize: 8, textOffsetY: -4 },
    ],
    // 화주사
    owner: {
      threshold: 40,
      defaultFontSize: 8, // fonts.medium
      smallFontSize: 7, // fonts.small
    },
    // 공급사
    supplier: [
      { maxLength: 26, fontSize: 12, textOffsetY: 1 },
      { maxLength: 31, fontSize: 10, textOffsetY: 1 },
      { maxLength: 36, fontSize: 8, textOffsetY: 1 },
      { maxLength: Infinity, fontSize: 8, textOffsetY: 0 },
    ],
  },
} as const;
